import { locationDefinition } from "./location-definition";
import { productDefinition } from "./product-definition";
import { staffDefinition } from "./staff-definition";
import { terminalDefinition } from "./terminal-definition";
import { payTypeDefinition } from "./payment-type-definition";
import { paymentMethodDefinition } from "./payment-method-definition";
import { customerDefinition } from "./customer-definition";
import { receiptTemplateTypeDefinition } from "./receipt-template-type-defintion";
import { receiptTemplateDefinition } from "./receipt-template-definition";
import { layoutNodeDefinition } from "./layout-node-definition";
import { layoutDefinition } from "./layout-definition";
import { categoryDefinition } from "./category-definition";
import { departmentDefinition } from "./department-definition";
import { serialNumberDefinition } from "./serial-number-definition";
import { supplierDefinition } from "./supplier-definition";
import { taxGroupDefinition } from "./tax-group-definition";
import { retailerPayTypeDefinition } from "./retailer-pay-type-definition";
import { docketTemplateTypeDefinition } from "./docket-template-type-definition";
import { docketTemplateDefinition } from "./docket-template-definition";
import { productKitDefinition } from "./product-kit-definition ";
import { productKitItemDefinition } from "./product-kit-item-definition";

export const allStartupDefinitions = [
  departmentDefinition,
  categoryDefinition,
  supplierDefinition,
  productDefinition,
  layoutDefinition,
  layoutNodeDefinition,
  locationDefinition,
  staffDefinition,
  payTypeDefinition,
  paymentMethodDefinition,
  customerDefinition,
  receiptTemplateTypeDefinition,
  receiptTemplateDefinition,
  serialNumberDefinition,
  terminalDefinition,
  taxGroupDefinition,
  // stockCountDefinition,
  retailerPayTypeDefinition,
  docketTemplateTypeDefinition,
  docketTemplateDefinition,
  productKitDefinition,
  productKitItemDefinition,
];

export const allStocktakeDefinitions = [];
